import { API } from '@/BeatoutAPI';
import { helpers } from '../helpers';
import store, { moduleActionContext } from '@/store';
const state = {
    server: {
        http_port: '',
        ice_servers: []
    },
    cameras: {},
    modus: {},
    selectedCamera: '',
    autoToggle: true,
    autoTurnOnToggle: null
};
const getters = {};
const mutations = {
    set(camerasState, data) {
        var _a;
        camerasState.cameras = data.streams;
        camerasState.server = data.server;
        camerasState.modus = (_a = data.modus) !== null && _a !== void 0 ? _a : {};
    },
    setSelectedCamera(cameraState, params) {
        console.log('setSelectedCamera');
        cameraState.selectedCamera = params.selectedId;
        cameraState.autoToggle = params.toggle;
        store.dispatch.streamdeck.sendSelectedCameraId(params.selectedId);
        store.dispatch.streamdeck.sendCameraToggle(params.toggle);
        if (params.toggle === false) {
            if (cameraState.autoTurnOnToggle)
                clearTimeout(cameraState.autoTurnOnToggle);
            // @ts-ignore
            cameraState.autoTurnOnToggle = setTimeout(() => {
                store.commit.cameras.setCameraToggle(true);
            }, 30000);
        }
    },
    setCameraToggle(cameraState, enabled) {
        cameraState.autoToggle = enabled;
        store.dispatch.streamdeck.sendCameraToggle(enabled);
        if (cameraState.autoTurnOnToggle)
            clearTimeout(cameraState.autoTurnOnToggle);
        cameraState.autoTurnOnToggle = null;
    }
};
const actions = {
    async get(context) {
        const { commit } = camerasModuleActionContext(context);
        const response = await API.getRequest().get('cameras');
        commit.set(response.data);
    },
    async update(context, { cameras, modus }) {
        const { state, dispatch } = camerasModuleActionContext(context);
        const response = await API.getRequest().put('cameras', JSON.stringify({
            server: state.server,
            streams: cameras,
            modus: modus
        }));
        await dispatch.get();
        return response.status == 200;
    },
    async subscribe(context) {
        const { dispatch, state, commit } = camerasModuleActionContext(context);
        await helpers.subscribe('cameras', { repeat: 5000 }, async () => {
            dispatch.get();
            if (state.autoToggle) {
                let index = Object.keys(state.cameras).indexOf(state.selectedCamera);
                index = (index + 1) % Object.keys(state.cameras).length;
                const id = Object.keys(state.cameras)[index];
                if (id)
                    commit.setSelectedCamera({ selectedId: id, toggle: true });
            }
        });
    },
    async unsubscribe(_context) {
        await helpers.unsubscribe('cameras');
    }
};
const camerasModule = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default camerasModule;
export const camerasModuleActionContext = (context) => moduleActionContext(context, camerasModule);
